import { Icon } from 'components/icon'
import { SAddButton } from './AddButton.styled'
import { Text } from 'components/Typography'
import { useTranslation } from 'next-i18next'
import { useWindowSize } from 'utils/hooks'
import { GenericFunction } from 'utils/types'

export const AddButton = (props: { onClick?: GenericFunction }) => {
  const { t } = useTranslation('life_stories')
  const { isDesktop } = useWindowSize()

  return (
    <SAddButton type="button" variant="secondary" size="large" onClick={props.onClick}>
      {isDesktop ? (
        <>
          <Icon name="FileUpload" />
          {t('life_stories.inside_page.add_button_desktop')}
        </>
      ) : (
        <>
          <Icon name="Plus" />
          <Text variant="body" css={{ opacity: '0.5', fontWeight: 'normal' }}>
            {t('life_stories.inside_page.add_button_mobile')}
          </Text>
        </>
      )}
    </SAddButton>
  )
}
